module.exports = __webpack_public_path__ + "static/media/lyftLogo.9dfd9a48.png";